import MenuPageItem from "./MenuPageItem";

export default function MenuPageItemCopy({ formUtility, onClick }) {

    function handleOnClick(e) {
        if (!onClick || formUtility.fieldsDisabled)
            return;

        formUtility.showPrompt(
            "Copy",
            "Copy this record?",
            onClick
        );
    }

    return (
        <>
            {
                onClick && formUtility.data && !formUtility.hasChanges
                    ? <MenuPageItem iconClassName="fas fa-copy" text="COPY" onClick={handleOnClick} />
                    : null
            }
        </>
    );
}